export const getLPCs = () => {
    const LPCS = [
    "4-County Electric Power Association",
    "Albertville Municipal Utilities Board",
    "Alcorn County Electric Power Association",
    "Appalachian Electric Cooperative",
    "Arab Electric Cooperative",
    "Athens Utilities (AL)",
    "Athens Utilities Board",
    "Benton County Electric System (TN)",
    "Benton Electric System (KY)",
    "Bessemer Electric Service",
    "Blue Ridge Mountain Electric Membership Corporation",
    "Bolivar Energy Authority",
    "Bowling Green Municipal Utilities",
    "BrightRidge",
    "Bristol Tennessee Essential Services",
    "Brownsville Energy Authority",
    "BVU Authority",
    "Caney Fork Electric Cooperative, Inc.",
    "Carroll County Electrical Department",
    "Clarksville Department of Electricity dba CDE Lightband",
    "Central Electric Power Association",
    "Cherokee Electric Cooperative",
    "Chickamauga Electric System",
    "Chickasaw Electric Cooperative",
    "City of Aberdeen Electric Department",
    "City of Alcoa Electric Department",
    "City of Amory Utilities",
    "City of Dayton Electric Department",
    "City of Elizabethton Electric Department",
    "City of Macon Electric Department",
    "City of Maryville Electric Department",
    "City of New Albany Light, Gas & Water",
    "City of Oak Ridge Electric Department",
    "City of Okolona Electric Department",
    "City of Oxford Electric Department",
    "City of Tupelo Water & Light Department",
    "City of Water Valley Electric Department",
    "Cleveland Utilities",
    "Clinton Utilities Board",
    "Columbia Power & Water Systems",
    "Columbus Light and Water Department",
    "Cookeville Electric Department",
    "Courtland Electric Department",
    "Covington Electric System",
    "Cullman Electric Cooperative",
    "Cullman Power Board",
    "Cumberland Electric Membership Corporation",
    "Decatur Utilities",
    "Dickson Electric System",
    "Direct Serve/TVA",
    "Duck River Electric Membership Corporation",
    "Dyersburg Electric System",
    "East Mississippi Electric Power Association",
    "Electric Board of Guntersville",
    "EPB",
    "Erwin Utilities Authority",
    "Etowah Utilities",
    "Fayetteville Public Utilities",
    "Florence Utilities",
    "Forked Deer Electric Cooperative, Inc.",
    "Fort Loudoun Electric Cooperative",
    "Fort Payne Improvement Authority",
    "Franklin Electric Cooperative",
    "Franklin Electric Plant Board",
    "Fulton  Electric System",
    "Gallatin Department of Electricity",
    "Gibson Electric Membership Corporation",
    "Glasgow Electric Plant Board",
    "Greeneville Energy Authority",
    "Harriman Utility Board",
    "Hartselle Utilities",
    "Hickman Electric System",
    "Hickman-Fulton Counties Rural Electric Cooperative Corporation",
    "Holly Springs Utility Department",
    "Holston Electric Cooperative",
    "Hopkinsville Electric System",
    "Humboldt Utilities",
    "Huntsville Utilities",
    "I don’t see my LPC on this list",
    "Jackson Energy Authority",
    "Jellico Utilities",
    "Joe Wheeler Electric Membership Corporation",
    "Knoxville Utilities Board",
    "LaFollette Utilities",
    "Lawrenceburg Utility Systems",
    "Lenoir City Utilities Board",
    "Lewisburg Electric System",
    "Lexington Electric System",
    "Loudon Utilities",
    "Louisville Utilities",
    "Marshall-DeKalb Electric Cooperative",
    "Mayfield Electric & Water Systems",
    "McMinnville Electric System",
    "Memphis Light, Gas and Water Division",
    "Meriwether Lewis Electric Cooperative",
    "Middle Tennessee Electric",
    "Milan Department of Public Utilities",
    "Monroe County Electric Power Association",
    "Morristown Utilities Commission",
    "Mountain Electric Cooperative",
    "Mt. Pleasant Power System",
    "Murphy Electric Power Board",
    "Murray Electric System",
    "Muscle Shoals Electric Board",
    "Natchez Trace Electric Power Association",
    "Nashville Electric Service",
    "Newbern Electric Water & Gas",
    "Newport Utilities",
    "North Alabama Electric Cooperative",
    "North East Mississippi Electric Power Association",
    "North Georgia Electric Membership Corporation",
    "Northcentral Electric Cooperative",
    "Paris Board of Public Utilities",
    "Pennyrile Rural Electric Cooperative Corporation",
    "Pulaski Electric System (PES)",
    "Philadelphia Utilities",
    "Pickwick Electric Cooperative",
    "Plateau Electric Cooperative",
    "Pontotoc Electric Power Association",
    "Powell Valley Electric Cooperative",
    "Prentiss County Electric Power Association",
    "Ripley Power & Light Company",
    "Rockwood Electric Utility",
    "Russellville Electric Board (AL)",
    "Russellville Electric Plant Board (KY)",
    "Sand Mountain Electric Cooperative",
    "Scottsboro Electric Power Board",
    "Sequachee Valley Electric Cooperative",
    "Sevier County Electric System",
    "Sheffield Utilities",
    "Shelbyville Power System",
    "Smithville Electric System",
    "Southwest Tennessee Electric Membership Corporation",
    "Sparta Electric & Public Works",
    "Springfield Electric",
    "Starkville Utilities",
    "Sweetwater Utilities Board",
    "Tallahatchie Valley Electric Power Association",
    "Tarrant Electric Department",
    "Tennessee Valley Electric Cooperative",
    "Tippah Electric Power Association",
    "Tishomingo County Electric Power Association",
    "Tombigbee Electric Power Association",
    "Trenton Light & Water Department",
    "Tri-County Electric Membership Corporation",
    "Tri-State Electric Membership Corporation",
    "Tullahoma Utilities Authority",
    "Tuscumbia Electricity Department",
    "Union City Energy Authority (UCEA)",
    "Upper Cumberland Electric Membership Corporation",
    "Volunteer Energy Cooperative",
    "Warren Rural Electric Cooperative Corporation",
    "Weakley County Municipal Electric System",
    "West Kentucky Rural Electric Cooperative Corporation",
    "West Point Electric System",
    "Winchester Utility System",
    ]

    return  LPCS.filter((c, i, LPCS) => LPCS.indexOf(c) === i) 
}
